import {isMobile} from "../../../../../js/app/util";

export default () => {
  const container = document.getElementById("taboola-container");
  let containerID = '';
  let containerPlacement = '';

  if(container) {
    if (isMobile) {
      containerID =  "taboola-mobile-below-article-thumbnails";
      containerPlacement = 'Mobile Below Article Thumbnails';
    } else {
      containerID = "taboola-below-article-thumbnails";
      containerPlacement = 'Below Article Thumbnails';
    }
    container.id = containerID;

    window._taboola = window._taboola || [];
    _taboola.push({
      mode: 'thumbnails-a',
      container: containerID,
      placement: containerPlacement,
      target_type: 'mix'
    });
  }
}
